import { Link } from "react-router-dom";
import { CATEGORIES } from "@/config/categories";

export const MegaMenu = ({ counts = {}, onClose }) => {
  return (
    <>
      <div className="fixed inset-0 z-40 bg-slate-900/20 backdrop-blur-[1px]" onClick={onClose} data-testid="mega-menu-backdrop" />
      <div
        className="absolute top-full left-0 w-full bg-white border-b border-slate-200 shadow-2xl z-50 animate-in slide-in-from-top-4 fade-in duration-200"
        data-testid="category-mega-menu"
      >
        <div className="mx-auto max-w-6xl px-4 sm:px-6 py-6">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400 mb-4">Alle Kategorien</p>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
            {CATEGORIES.map((c) => {
              const Icon = c.icon;
              const count = counts[c.name] || 0;
              return (
                <Link
                  key={c.name}
                  to={`/kategorie/${encodeURIComponent(c.name)}`}
                  onClick={onClose}
                  className="group flex items-center gap-3 p-3 rounded-xl hover:bg-slate-50 transition-all"
                  data-testid={`mega-cat-${c.name}`}
                >
                  <div className="h-11 w-11 rounded-xl flex items-center justify-center shrink-0 transition-transform group-hover:scale-110" style={{ backgroundColor: `${c.color}15` }}>
                    <Icon className="h-5 w-5" style={{ color: c.color }} strokeWidth={2.2} />
                  </div>
                  <div className="min-w-0">
                    <p className="font-outfit font-bold text-slate-900 text-sm truncate group-hover:text-pink-500 transition-colors">{c.name}</p>
                    <p className="text-xs text-slate-400">{count > 0 ? `${count} Deals` : "Bald verfügbar"}</p>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default MegaMenu;
